export default "__VITE_ASSET__CRYWfzBC__"